<p-button
  label="Volver"
  icon="pi pi-arrow-left"
  [text]="true"
  styleClass="page-back-button"
  (onClick)="goToAdmin()" />
<div
  class="surface-ground justify-content-center flex min-h-screen overflow-hidden pt-1">
  <div class="flex flex-column w-full">
    <ls-toast-atom />
    <ls-card-atom title="Usuarios">
      <div class="users-kpis">
        <div class="metric-card metric-card--static">
          <span class="metric-card__icon metric-card__icon--ok"><i class="pi pi-users"></i></span>
          <span class="metric-card__body">
            <span class="metric-card__label">Total de usuarios</span>
            <span class="metric-card__value">{{ totalUsersCount }}</span>
          </span>
        </div>

        <div class="metric-card metric-card--static">
          <span class="metric-card__icon metric-card__icon--ok"><i class="pi pi-bell"></i></span>
          <span class="metric-card__body">
            <span class="metric-card__label">Con push activado</span>
            <span class="metric-card__value">{{ pushEnabledCount }}</span>
            <span class="metric-card__hint">{{ pushEnabledPercent }}% del total</span>
          </span>
        </div>

        <div class="metric-card metric-card--static">
          <span class="metric-card__icon metric-card__icon--warn"><i class="pi pi-user-minus"></i></span>
          <span class="metric-card__body">
            <span class="metric-card__label">Sin conexión reciente</span>
            <span class="metric-card__value">{{ inactiveUsersCount }}</span>
            <span class="metric-card__hint">Más de 30 días o nunca</span>
          </span>
        </div>
      </div>

      <p-tabs [(value)]="activeView">
        <p-tablist>
          <p-tab value="usuarios">Usuarios</p-tab>
          <p-tab value="instalacion">Por instalación</p-tab>
        </p-tablist>
        <p-tabpanels>
          <p-tabpanel value="usuarios">
          <div>
            <p-table
              #dt
              [rows]="10"
              [paginator]="true"
              [globalFilterFields]="['nombre', 'apellidos', 'email']"
              [columns]="cols"
              [value]="users"
              responsiveLayout="stack"
              [breakpoint]="'960px'"
              [exportHeader]="'customExportHeader'"
              [loading]="isLoading()"
              [showLoader]="false"
              [styleClass]="'p-datatable-sm users-table'"
              [resizableColumns]="true"
              columnResizeMode="fit"
              [stateKey]="stateKey"
              [stateStorage]="'local'"
              (onStateSave)="saveTableState($event)"
              [showCurrentPageReport]="true"
              currentPageReportTemplate="Mostrando {first} - {last} de {totalRecords} usuarios">
              <ng-template pTemplate="caption">
                <div
                  class="flex align-items-center justify-content-between pb-2">
                  <ls-button-icon-atom
                    label="Nuevo Usuario"
                    icon="pi pi-plus"
                    severity="primary"
                    (onClick)="editUser(null)"></ls-button-icon-atom>

                  <div class="flex gap-2">
                    <ls-input-atom
                      placeholder="Buscar..."
                      [showIcon]="false"
                      (onInput)="onGlobalFilter(dt, $event)" />
                    <ls-button-icon-atom
                      label="Export"
                      icon="pi pi-external-link"
                      severity="primary"
                      (onClick)="exportToExcel(dt)"></ls-button-icon-atom>
                  </div>
                </div>
              </ng-template>
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th
                    scope="column"
                    *ngFor="let col of columns"
                    pResizableColumn
                    [pSortableColumn]="col.field">
                    <div class="flex align-items-center justify-content-between gap-2">
                      <span class="flex align-items-center gap-1">
                        {{ col.header }}
                        <p-sortIcon [field]="col.field" />
                      </span>

                      @if (col.type === 'text') {
                      <p-columnFilter type="text" [field]="col.field" display="menu" />
                      } @else if (col.type === 'role') {
                      <p-columnFilter
                        [field]="col.field"
                        matchMode="equals"
                        display="menu"
                        [showMatchModes]="false"
                        [showOperator]="false"
                        [showAddButton]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-select
                            [ngModel]="value"
                            (onChange)="filter($event.value)"
                            [options]="roleOptions"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Cualquiera"
                            [showClear]="true"
                            appendTo="body" />
                        </ng-template>
                      </p-columnFilter>
                      } @else if (col.type === 'boolean') {
                      <p-columnFilter
                        [field]="col.field"
                        matchMode="equals"
                        display="menu"
                        [showMatchModes]="false"
                        [showOperator]="false"
                        [showAddButton]="false">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                          <p-select
                            [ngModel]="value"
                            (onChange)="filter($event.value)"
                            [options]="pushOptions"
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Cualquiera"
                            [showClear]="true"
                            appendTo="body" />
                        </ng-template>
                      </p-columnFilter>
                      } @else if (col.type === 'date') {
                      <p-columnFilter type="date" [field]="col.field" display="menu" />
                      }
                    </div>
                  </th>
                  <th scope="column"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr *ngIf="!isLoading()">
                  <td *ngFor="let col of columns">
                    @if (col.field === 'role') {
                    <p-tag [value]="getTypeName(rowData[col.field])" />
                    } @else if (col.field === 'pushEnabled') {
                    <i
                      [class]="rowData.pushEnabled ? 'pi pi-bell text-primary-600' : 'pi pi-bell-slash text-color-secondary'"
                      [pTooltip]="rowData.pushEnabled ? 'Push activado' : 'Push desactivado'"
                      tooltipPosition="top"></i>
                    } @else if (col.field === 'lastLoginAt') {
                    {{ timeAgo(rowData.lastLoginAt) }}
                    } @else {
                    {{ rowData[col.field] }}
                    }
                  </td>

                  <td>
                    <div class="flex gap-2 justify-content-end">
                      <ls-button-icon-atom
                        severity="primary"
                        [size]="'small'"
                        [link]="true"
                        pTooltip="Instalaciones asignadas"
                        tooltipPosition="top"
                        (onClick)="editInstallationAssigned(rowData)">
                        <i
                          class="ph-duotone ph-buildings text-4xl text-primary-600 hover:text-primary-800"></i>
                      </ls-button-icon-atom>
                      <ls-button-icon-atom
                        severity="primary"
                        [size]="'small'"
                        [link]="true"
                        pTooltip="Editar usuario"
                        tooltipPosition="top"
                        (onClick)="editUser(rowData.id)">
                        <i
                          class="ph-duotone ph-note-pencil text-4xl text-primary-600 hover:text-primary-800"></i>
                      </ls-button-icon-atom>
                      <ls-button-icon-atom
                        severity="primary"
                        [size]="'small'"
                        [link]="true"
                        pTooltip="Restablecer contraseña"
                        tooltipPosition="top"
                        (onClick)="sendResetPasswordEmail(rowData)">
                        <i
                          class="ph-duotone ph-password text-4xl text-primary-600 hover:text-primary-800"></i>
                      </ls-button-icon-atom>
                      @if(customForm) {
                      <ls-button-icon-atom
                        severity="primary"
                        [size]="'small'"
                        [link]="true"
                        pTooltip="Formulario personalizado"
                        tooltipPosition="top"
                        (onClick)="openCustomForm(rowData)">
                        <i
                          class="ph-duotone ph-faders text-4xl text-primary-600 hover:text-primary-800"></i>
                      </ls-button-icon-atom>
                      }
                      <!-- <ls-button-icon-atom
                        severity="primary"
                        [size]="'small'"
                        [link]="true"
                        (onClick)="resetPassword(rowData)">
                        <i
                          class="ph-duotone ph-password text-4xl text-primary-600 hover:text-primary-800"></i>
                      </ls-button-icon-atom> -->

                      <!-- Historial de navegacion del usuario (ticket #293).
                           Navega por ruta y no abre el componente porque esta
                           lib no puede importar de la aplicacion. -->
                      <ls-button-icon-atom
                        severity="primary"
                        [size]="'small'"
                        [link]="true"
                        pTooltip="Historial de navegación"
                        tooltipPosition="top"
                        (onClick)="viewNavigationHistory(rowData)">
                        <i
                          class="ph-duotone ph-clock-counter-clockwise text-4xl text-primary-600 hover:text-primary-800"></i>
                      </ls-button-icon-atom>

                      <ls-button-icon-atom
                        severity="danger"
                        [size]="'small'"
                        [link]="true"
                        pTooltip="Eliminar usuario"
                        tooltipPosition="top"
                        (onClick)="deleteUser(rowData)">
                        <i
                          class="ph-duotone ph-trash text-4xl text-red-600 hover:text-red-800"></i>
                      </ls-button-icon-atom>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="loadingbody" let-columns="columns">
                <ls-progress-spinner-atom></ls-progress-spinner-atom>
              </ng-template>
            </p-table>
          </div>
          </p-tabpanel>
          <p-tabpanel value="instalacion">
            <lib-installation-users-view></lib-installation-users-view>
          </p-tabpanel>
        </p-tabpanels>
      </p-tabs>
    </ls-card-atom>
  </div>
  <p-confirmDialog [style]="{ width: '450px' }" />
</div>
<p-toast key="users"></p-toast>

